import { useReducer } from 'react';
import { setFilterTextActionType, setFilterTextHandler, setFilterTextAction } from './actions/setFilterTextAction';
import { setFilterTagsActionType, setFilterTagsHandler, setFilterTagsAction } from './actions/setFilterTagsAction';
import { setSelectedFileSystemNodePathActionType, setSelectedFileSystemNodePathHandler, setSelectedFileSystemNodePathAction } from './actions/setSelectedFileSystemNodePathAction';
import { setDirectoryContentTargetItemIndexActionType, setDirectoryContentTargetItemIndexHandler, setDirectoryContentTargetItemIndexAction } from './actions/setDirectoryContentTargetItemIndexAction';
import { Map } from 'immutable';

const initialState = {
    selectedFileSystemNodePath: [],
    predictedSelectedFileSystemNodeType: 'directory',
    directoryContentTargetItemIndexes: new Map(),
    filterText: "",
    filterTags: [],
}

let actionTypes = [];

actionTypes[setFilterTextActionType] = {
    handler: setFilterTextHandler,
    action: setFilterTextAction,
};
export { setFilterTextAction }

actionTypes[setFilterTagsActionType] = {
    handler: setFilterTagsHandler,
    action: setFilterTagsAction,
};
export { setFilterTagsAction }

actionTypes[setSelectedFileSystemNodePathActionType] = {
    handler: setSelectedFileSystemNodePathHandler,
    action: setSelectedFileSystemNodePathAction,
};
export { setSelectedFileSystemNodePathAction }

actionTypes[setDirectoryContentTargetItemIndexActionType] = {
    handler: setDirectoryContentTargetItemIndexHandler,
    action: setDirectoryContentTargetItemIndexAction,
};
export { setDirectoryContentTargetItemIndexAction }

export function useFileExplorerReducer() {
    return useReducer(reducer, initialState);
}

function reducer(state, action) {
    const actionType = actionTypes[action.type];
    const actionHandler = actionType ? actionType.handler : null;
    if (actionHandler) {
        return actionHandler(state, action);
    }
    throw new Error('fileExplorerReducer has no action type: ' + action.type);
}